import { render } from "./BerechnungFormRow.vue?vue&type=template&id=b58da540&scoped=true"
const script = {}

import "./BerechnungFormRow.vue?vue&type=style&index=0&id=b58da540&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58da540"]])

export default __exports__